import React from 'react';
import { Box } from '@common-fe/common-fe';

import PERMISSIONS from '@/common/permissions';
import ROUTES from '@/common/routes';
import { useHasAccess } from '@/modules/core';
import { Access } from '@/modules/core/components';
import Topbar from '@/modules/core/components/Topbar';
import { useBreadcrumbs } from '@/modules/core/hooks/useBreadcrumbs';
import { PlanOmnibusBalanceReportDetails } from '@/modules/Reports/ReportDetails';

const PlanOmnibusBalanceReportPage = () => {
  useBreadcrumbs([
    {
      route: ROUTES.NEW_REPORTS,
      title: 'Reports',
    },
    {
      route: ROUTES.PLAN_OMNIBUS_BALANCE_REPORT,
      title: 'Plan Omnibus Balance',
    },
  ]);
  const isHasPermission = useHasAccess([
    {
      permission: PERMISSIONS.REPORTS,
    },
  ]);
  if (!isHasPermission) {
    return null;
  }

  return (
    <Access
      accessRequirements={[
        {
          permission: PERMISSIONS.VIEW_OMNI_BALANCES,
        },
      ]}
    >
      <Box width="100%" data-testid="topbar-wrapper">
        <div>
          <Topbar />
        </div>
        <Box>
          <Box margin={{ top: 'spacing24' }}>
            <PlanOmnibusBalanceReportDetails />
          </Box>
        </Box>
      </Box>
    </Access>
  );
};

export default PlanOmnibusBalanceReportPage;
